import { Component, OnInit } from '@angular/core';
import { Products } from 'src/app/model/products.model';
import { ProductService } from 'src/app/services/product/product.service';
import { Productcategory } from 'src/app/model/productcategory.model';
import { OrderService } from 'src/app/services/order/order.service';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-cartitems',
  templateUrl: './cartitems.component.html',
  styleUrls: ['./cartitems.component.css']
})
export class CartitemsComponent implements OnInit {

  //product: Products;
  category: Productcategory;
  cartItems: any;
  totalPrice: any;

  constructor(private productServices: ProductService, private router: Router, private orderServices: OrderService) {
    // this.productServices.getProductCategory().subscribe(
    //   (data: any) => {
    //     this.category = data;
    //     console.log(this.category);
    //   }
    // )
  }

  ngOnInit() {
    // this.productServices.getProductList().subscribe(
    //   (data: any) => {
    //     this.product = data;
    //     console.log(this.product);
    //   }
    // )
    this.getCartItems();
  }

  addtocart(productId: number) {
    this.orderServices.addToCart(productId).subscribe(
      (data: any) => {
        if (data == true) {
          //alert("added");
          this.getCartItems();
        }
        else {
          alert("already added");
        }
      }
    )
  }

  onQuantityChange(quantity: number) {
    //console.log(quantity);
    //alert(quantity);
    if (quantity < 0) {
      alert("quantity can't be less than 1");
    }
    else {
      debugger;
      this.totalPrice = 0.0;
      for (var i = 0; i < this.cartItems.length; i++) {
        var unitprice = this.cartItems[i].price;
        var itemprice = this.cartItems[i].orderQuantity * unitprice;
        //pricenum = pricenum.replace('$','');
        //var pricenumfloat = parseFloat(pricenum); 
        this.totalPrice = this.totalPrice + itemprice;
        this.totalPrice = Math.round(this.totalPrice * 100) / 100;
      }
    }

  }

  updateCart()
  {
    this.orderServices.updateCartItems(this.cartItems).subscribe(
      (data : any) => {

      }
    );
  }



  getCartItems() {
    this.totalPrice = 0.0;
    this.orderServices.getUserCartItems().subscribe(
      (data: any) => {
        this.cartItems = data;
        console.log(this.cartItems);

        if (!isNullOrUndefined(this.cartItems)) {
          this.totalPrice = 0.0;
          for (var i = 0; i < this.cartItems.length; i++) {
            var unitprice = this.cartItems[i].price;
            var itemprice = this.cartItems[i].orderQuantity * unitprice;
            //pricenum = pricenum.replace('$','');
            //var pricenumfloat = parseFloat(pricenum); 
            this.totalPrice = this.totalPrice + itemprice;
            this.totalPrice = Math.round(this.totalPrice * 100) / 100;
          }
        }

      }
    )
  }

  removefromcart(cartId: number) {
    this.orderServices.removeFromCart(cartId).subscribe(
      (data: any) => {
        if (data == true) {
          //alert("added");
          this.getCartItems();
          //this.getCartItems();
        }
        else {
          alert("already removed");
        }
      }
    )
  }

  placeOrder() {
    if (this.totalPrice < 1) {
      alert("quantity can't be less than 1");
    }
    else {
      this.router.navigate(['/confirmorder']);
      console.log(this.cartItems);
      this.orderServices.placeorder(this.cartItems).subscribe(
        (data: any) => {
          if (data != null) {
            this.router.navigate(['/confirmorder', data.ordrNumber]);
            //alert("Order Placed");
          }
          console.log(data);
        }
      )
    }
  }


}
